const STORAGE_KEY = 'hcp_id_verification';

/**
 * @param {import('@/libs/services/storage').default} storage
 * @param {string} prefix
 * @param {object} verification
 * @param {string} verification.country
 * @param {string} verification.number
 */
export function saveHcpIdVerification(storage, prefix, { country, number }) {
    const verification = { country, number, verifiedAt: new Date().toISOString() };
    storage.setItemWithPrefix(prefix, STORAGE_KEY, JSON.stringify(verification));
}

/**
 * @param {import('@/libs/services/storage').default} storage
 * @param {string} prefix
 * @param {string} country
 * @returns {HcpId.Verification|undefined}
 */
export function getHcpIdVerification(storage, prefix, country) {
    const storedValue = storage.getItemWithPrefix(prefix, STORAGE_KEY);
    if (!storedValue) {
        return undefined;
    }

    try {
        const verification = JSON.parse(storedValue);
        return verification?.country === country ? verification : undefined;
    } catch {
        return undefined;
    }
}

/**
 * @param {import('@/libs/services/storage').default} storage
 * @param {string} prefix
 */
export function removeHcpIdVerification(storage, prefix) {
    storage.removeItemWithPrefix(prefix, STORAGE_KEY);
}
